import { EmptyButton } from 'mol-ui';
import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const Col = styled(Col_)`
    align-items: center;
    display: flex;
`;

export const Container = styled.div`
    border-radius: 25px;
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: 13px;
    min-width: 340px;
    overflow-y: auto;
    padding: 20px 20px 0px 20px;
    width: 100%;
`;

export const Footer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
`;

export const IconContainer = styled(EmptyButton)`
    display: inline-flex;
    margin-left: 2px;
    margin-right: 2px;
`;

export const InfoContainer = styled.div`
    border: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    margin-top: 10px;
    max-height: 500px;
    overflow: auto;
    padding: 10px;
`;

export const InfoRow = styled.div`
    border-bottom: 1px dashed ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    min-width: 600px;
    padding: 10px 5px;
    width: 100%;
    :last-child {
        border-bottom: 0px;
    }
`;

export const Message = styled.div`
    font-style: italic;
`;

export const Row = styled(Row_)`

`;

export const Session = styled.div`
    color: ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    font-size: 9px;
    text-align: right;
    width: 100%;
`;

export const TextContainer = styled.div`
    display: inline-flex;
`;

export const Title = styled.div`
    font-size: 14px;
    margin-bottom: 10px;
    text-decoration: underline;
`;
